export default "__VITE_ASSET__e0f13d38__"